import { Routes } from '@angular/router';
import { isAuthenticated } from './auth/auth.guard';
import { MainComponent } from './components/main/main.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { VerifyingSessionComponent } from './components/verifying-session/verifying-session.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/main',
        pathMatch: 'full',
    },
    {
        path: 'main',
        component: MainComponent,
        canActivate: [isAuthenticated],
    },
    {
        path: 'verifying-session',
        component: VerifyingSessionComponent,
    },
    {
        path: 'unauthorized',
        component: UnauthorizedComponent,
    },
    {
        path: '**',
        redirectTo: '/main',
    },
];
